import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { StyledParenthesisedContent } from "app/pages/sales-intelligence/common-components/styles";

import type { FiltersCategoryItem } from "../../types/category";

type Props = {
    category: FiltersCategoryItem;
    count?: number;
};

export const FilterCategorySectionTitle = ({ category, count }: Props): ReactElement => {
    const { translate } = useTranslate();
    const CategoryIcon = category.icon;
    const Badge = category.badge;

    return (
        <Flex
            alignItems="center"
            gap="4px"
            data-automation={`filter-panel.category-section.${category.id}`}
        >
            <CategoryIcon
                size="xs"
                color={colorsPalettes.carbon[250]}
            />

            <Box color={colorsPalettes.carbon[300]}>
                <Text
                    fontVariant="sectionTitle"
                    color={colorsPalettes.carbon[300]}
                    cursor="default"
                >
                    {translate(category.titleKey)}
                </Text>
                {count ? (
                    <StyledParenthesisedContent color={colorsPalettes.carbon[300]}>{count}</StyledParenthesisedContent>
                ) : null}
            </Box>

            {Badge ? <Badge /> : null}
        </Flex>
    );
};
